import { afterNextRender, ChangeDetectionStrategy, Component, inject, input, OnInit, output, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { CdkPortalOutlet, TemplatePortal } from '@angular/cdk/portal';
import { ToolbarPortalService } from './toolbar-portal.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { NgOptimizedImage } from '@angular/common';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { BaseComponent } from '../../state/base.component';

@Component({
  selector: 'oo-app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbar, MatToolbarRow, RouterLink, CdkPortalOutlet, MatMenuTrigger, NgOptimizedImage, MatMenu, MatMenuItem, MatIcon, MatDivider],
})
export class AppBarComponent extends BaseComponent implements OnInit {

  readonly router = inject(Router);
  readonly isSuperAdmin = input(false);
  readonly userImage = input<string>('');
  readonly isMobile = signal(true);
  readonly titlePortal = signal<TemplatePortal | undefined>(undefined);
  readonly bottomPortal = signal<TemplatePortal | undefined>(undefined);

  logout = output();
  private readonly toolbarPortalService = inject(ToolbarPortalService);
  private readonly breakpointObserver = inject(BreakpointObserver);

  constructor() {
    super();

    afterNextRender(() => {
      this.isMobile.set(this.breakpointObserver.isMatched('(max-width: 599px)'));
    });
  }

  ngOnInit() {
    this.addSubscription(
      this.toolbarPortalService.getTitleObservable()
        .subscribe((v) => {
          this.invokeOnNextTick(() => this.titlePortal.set(v!));
        }),
    );

    this.addSubscription(
      this.toolbarPortalService.getBottomObservable()
        .subscribe((v) => {
          this.invokeOnNextTick(() => this.bottomPortal.set(v));
        }),
    );
  }
}
